// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"030a6035","959":"36601086"}[chunkId] + ".chunk.js";
};